//import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import '@svgdotjs/svg.draggable.js'
// material
import { Card, CardHeader, Box } from '@mui/material';
//
//import { BaseOptionChart } from './BaseOptionChart';
import React from 'react';

// ----------------------------------------------------------------------

class NrExercicios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      /* chart cima big */
      chartOptionsArea: {
        chart: {
          id: "chartArea",
          toolbar: {
            autoSelected: "pan",
            show: false
          } 
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
              enabled: true,
              delay: 150
          },
          dynamicAnimation: {
              enabled: true,
              speed: 350
          }
        },
        colors: ['#1f78b4'],
        stroke: {
          width: 3
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime"
        },
        yaxis: [
          {
              axisTicks: {
                  show: true
              },
              axisBorder: {
                  show: false,
                  color: "#1f78b4"
              },
              labels: {
                  style: {
                      colors: "#1f78b4"
                  }
              },
              title: {
                  text: "N.º",
                  style: {
                      color: "#1f78b4"
                  }
              }
          },
        ],
      },
      /* barra deslizante de baixo */
      chartOptionsBrush: {
        chart: {
          id: "chartBrush",
          //foreColor: "#ccc",
          brush: {
            target: "chartArea",
            enabled: true
          },
          selection: {
            enabled: true,
            xaxis: {
              min: new Date("01 Jan 2022").getTime(),
              max: new Date("01 Jul 2022").getTime()
            }
          }
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
              enabled: true,
              delay: 150
          },
          dynamicAnimation: {
              enabled: true,
              speed: 350
          }
        },
        colors: ["#008FFB"],
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.91,
            opacityTo: 0.1
          }
        },/*
        grid: {
          borderColor: "#444"
        },
        markers: {
            size: 0
        },*/
        xaxis: {
          type: "datetime",
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 2
        }
      },
      series: [
        {
          data: this.generateDayWiseTimeSeries(
            new Date("01 Jan 2022").getTime(),
            185,
            {
              min: 30,
              max: 120
            }
          )
        }
      ]
    };
  }

  generateDayWiseTimeSeries(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = baseval;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

      series.push([x, y]);
      baseval += 86400000;
      i++;
    }
    return series;
  }

  render() {
    return (
      <Card>
        <CardHeader title="Exercícios realizados" />{/*subheader="(+43%) que no ano passado" />*/}
        <Box sx={{ p: 3, pb: 1 }} dir="ltr">
          {/*<ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={364} />*/}
          <div id="charts">
            <div id="chart1">
              <ReactApexChart
                options={this.state.chartOptionsArea}
                series={this.state.series}
                type="area"
                height="200"
              />
            </div>
            <div id="chart2">
              <ReactApexChart
                options={this.state.chartOptionsBrush}
                series={this.state.series}
                type="area"
                height="100"
              />
            </div>
          </div>
        </Box>
      </Card>
    );
  }
}

export default NrExercicios;
